export default "__VITE_ASSET__DFzXmKEn__"